import IntlMessageFormat from 'intl-messageformat';
import { Language } from 'commons/i18n/language.js';
import { validateObjectValue } from '@/util/objects.js';
import { loadIntl, getLoadersForLangAndFile } from './language_loaders.js';
import { LANGUAGE_FILES, LANGUAGES } from '@/constants/language.js';

const loadLanguageFile = (lang = LANGUAGES.DEFAULT, file = LANGUAGE_FILES.BASE) => {
    lang = validateObjectValue(LANGUAGES, lang, LANGUAGES.DEFAULT, `Attempting to load an unsupported language.  Defaulting to ${lang}`);
    file = validateObjectValue(LANGUAGE_FILES, file, LANGUAGE_FILES.BASE, `Attempting to load an unsupported language file.  Defaulting to ${file}`);
    const loaders = getLoadersForLangAndFile(lang, file);
    return loadIntl().then(loaders);
};

export const loadAndConvertLanguageFile = (languageName, file) =>
    loadLanguageFile(languageName, file).then((lang) => new Language(IntlMessageFormat, languageName, lang));
